import { memo } from 'react';
import _uniqueId from 'lodash/uniqueId';

const ToggleTab = (props) => {
    const { option: op, pose, input, selected, onClick } = props;
    const parsedLabel = typeof op === 'string' ? op : op.label;
    const parsedValue = typeof op === 'string' ? op.toLocaleLowerCase() : op.value;
    return (
        <>
            <option onClick={onClick} selected={Boolean(selected)} className={pose} data-value={parsedValue}>
                {parsedLabel}
            </option>
        </>
    );
};

const ToggleSwitch = (props) => {
    const { onChange, selected, disabled, options, id } = props;

    const position = selected === options[1].value ? 1 : 0;

    const switchPosition = (e) => {
        if (disabled) return;
        e.stopPropagation();
        const newValue = position === 0 ? options[1].value : options[0].value;
        onChange(newValue);
    };
    const onKeyDown = (e) => {
        if (e.code == 'Space') {
            switchPosition(e);
            e.preventDefault();
        }
    };
    return (
        <div id={id + 'field'} className={`toggle ctl full ${position ? 'right' : 'left'} ${disabled ? ' disabled' : ''}`} tabIndex={disabled ? -1 : 0} onKeyDown={onKeyDown} aria-labelledby={'label_' + id} role="listbox" aria-disabled={disabled} disabled={disabled}>
            <ToggleTab pose={'left'} onClick={switchPosition} selected={!position} option={options[0]} />
            <span className="separator" onClick={switchPosition}></span>
            <input type="checkbox" aria-hidden="true" id={id} value={!position ? options[0].value : options[1].value} onChange={switchPosition} />
            <ToggleTab pose={'right'} onClick={switchPosition} selected={position} option={options[1]} />
        </div>
    );
};
export default memo(ToggleSwitch);
